import { useEffect } from "react";
import { findFinancialAdvisor } from "../../financialAdvisor/slice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { ChatComponent } from "./chat";
import { findChats, findGroupChats, setSelectedChat } from "./slice";
import { UsersList } from "./usersList";

export function ChatViewV2() {
    const companyState = useAppSelector(state => state.company)
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(setSelectedChat(0))
    }, [])

    useEffect(() => {
        if (companyState.findCompanyStatus === 'successfully' && companyState.findCompanyResponse !== undefined) {
            dispatch(findChats({ firstUser: '', secondUser: '', topic: companyState.findCompanyResponse.id }))
            dispatch(findGroupChats({ topic: companyState.findCompanyResponse.id, user: [] }))
            dispatch(findFinancialAdvisor(companyState.findCompanyResponse.financialAdvisorId))
        }
    }, [companyState.findCompanyStatus])

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', gap: 16, height: 'calc(100vh - 250px)' }}>
            <UsersList />
            <ChatComponent />
        </div>
    )
}